<template>
    <el-dialog :title='$i18n.t("common.SEOManagement")' width="600px" :visible.sync="formVisible">
        <el-form ref="dataForm" :rules="formRules" :model="form" size="small" label-width="100px">

            <!--
            <el-form-item :label='$i18n.t("common.brand")' prop="brand">

                <dataSelect
                    style="width: 200px"
                    class="filter-item"
                    v-model="form.brand"
                    clearable
                    :codeType="'brand'"
                    :placeholder='$i18n.t("common.brand")'
                ></dataSelect>
            </el-form-item>

            -->
            <el-form-item :label='$i18n.t("common.name")' prop="name">

                <el-input v-model="form.name" />
            </el-form-item>
            <el-form-item :label='$i18n.t("common.PageURL")' prop="url">
                <el-input v-model="form.url" />
            </el-form-item>
            <el-form-item :label='$i18n.t("common.language")' prop="lang">
                <dataSelect
                    style="width: 200px"
                    class="filter-item"
                    v-model="form.lang"
                    clearable
                    :codeType="'lang'"
                    :placeholder='$i18n.t("common.language")'
                ></dataSelect>
            </el-form-item>
            <el-form-item :label='$i18n.t("common.PageTitle")'  prop="title">
                <el-input type="textarea" maxlength="500"
                          show-word-limit v-model="form.title" oninput="if(value.length>500)value=value.slice(0,500)"/>
            </el-form-item>
            <el-form-item :label='$i18n.t("common.Pagekeywords")' prop="keyword">
                <el-input type="textarea" maxlength="500"
                          show-word-limit v-model="form.keyWord" oninput="if(value.length>500)value=value.slice(0,500)"/>
            </el-form-item>
            <el-form-item :label='$i18n.t("common.PageDescription")' prop="description">
                <el-input type="textarea" maxlength="1000"
                          show-word-limit v-model="form.description" oninput="if(value.length>1000)value=value.slice(0,1000)" />
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="formVisible = false">  {{ $i18n.t("common.cancel") }} </el-button>
            <el-button type="primary" @click="doCreate()">  {{ $i18n.t("common.confirm") }} </el-button>
        </div>
    </el-dialog>
</template>

<script>
import DataSelect from '@/components/common/DataSelect';
import { time } from 'echarts';
function initFormBean() {
    const formBean = {
        name: null,
        brand: null,
        url: null,
        lang: null,
        title: "",
        keyWord: "",
        description: ""
    };
    return formBean;
}

export default {
    components: {
        DataSelect
    },
    name: 'SeoAdd',
    data() {
        return {
            form: {},
            formVisible: false,
            formRules: {
                name: [
                    { required: true, message: this.$i18n.t("common.Pleaseenteraname") , trigger: 'blur' },
                    { max: 20, message: this.$i18n.t("common.Thelengthcannotexceed20characters") , trigger: 'blur' }
                ],

                // brand: [
                //     { required: true, message: '请输入品牌', trigger: 'change' },
                //     { max: 50, message: this.$i18n.t("common.Thelengthcannotexceed50characters"), trigger: 'change' }
                // ],

                url: [
                    { required: true, message: this.$i18n.t("common.PleaseenterthepageURL"), trigger: 'blur' },
                    { max: 100, message:this.$i18n.t("common.Thelengthcannotexceed100characters"), trigger: 'blur' }
                ],
                lang: [
                    { required: true, message: this.$i18n.t("common.Pleaseenterthelanguage"), trigger: 'change' },
                    { max: 2, message:  this.$i18n.t("common.Thelengthcannotexceed2characters"), trigger: 'change' }
                ]
                // title: [
                //     { required: true, message: '请输入页面标题', trigger: 'blur' },
                //     { max: 100, message: '长度不能超过100个字符', trigger: 'blur' }
                // ],
                // keyword: [
                //     { required: true, message: '请输入页面关键字', trigger: 'blur' },
                //     { max: 200, message: '长度不能超过200个字符', trigger: 'blur' }
                // ],
                // description: [
                //     { required: true, message: '请输入页面描述', trigger: 'blur' },
                //     { max: 500, message: '长度不能超过500个字符', trigger: 'blur' }
                // ]
            }
        };
    },
    methods: {
        /**
         * 重置表单
         */
        resetForm() {
            this.form = initFormBean();
        },
        /**
         * 打开新建表单
         */
        handleCreate() {
            this.resetForm();
            this.formVisible = true;
            this.$nextTick(() => {
                this.$refs['dataForm'].clearValidate();
            });
        },
        /**
         * 执行新建操作
         */
        doCreate() {
            this.form.brand = this.$tenantBrand.getBrand();
            this.$refs['dataForm'].validate().then(() => {
                if (this.form.id == null) {
                    this.$store.dispatch('createSEO', this.form).then(() => {
                        this.$parent.doQueryList({ pageNo: this.$parent.query.current });
                        this.formVisible = false;
                        this.$message.success( this.$i18n.t("common.Operationsuccessful"));
                    });
                } else {
                    this.$store.dispatch('updateSEO', this.form).then(() => {
                        this.$parent.doQueryList({ pageNo: this.$parent.query.current });
                        this.formVisible = false;
                        this.$message.success(this.$i18n.t("common.Operationsuccessful"));
                    });
                }
            });
        }
    }
};
</script>
